import { Flex, Text, Tooltip } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';

import classes from './index.module.css';

interface ISectionText {
  bold?: boolean;
  center?: boolean;
  children?: any;
  info?: string;
  inline?: boolean;
  text?: string;
  variant?: string;
  withoutMargin?: boolean;
}

const SectionText = ({
  bold,
  center,
  children,
  info,
  inline,
  text,
  variant = 'white',
  withoutMargin
}: ISectionText) => {
  return (
    <Flex align={'center'} display={inline ? 'inline' : 'flex'}>
      <Text className={`${classes.text} ${classes[variant]}`} display={inline ? 'inline' : 'block'} ta={center ? 'center' : 'left'} fw={bold ? '700' : '300'} mr={withoutMargin ? 0 : 4}>
        {text ?? children}
      </Text>
      {info ?
        <Tooltip label={info}>
          <IconInfoCircle color='gray' size={18} />
        </Tooltip>
        : undefined}
    </Flex>
  )
}

export default SectionText;